import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from 'src/app/globals';
import { CRM } from 'src/app/models/crm/crmfunil';

@Injectable({
  providedIn: 'root'
})
export class CrmService {

  constructor(private http: HttpClient) { }

  consultarCRM() {
    return this.http.get<CRM[]>(globals.apiUrl + '/api/CRM/Lista');
  }

  consultarCRMParaWorkflow() {
    return this.http.get<CRM[]>(globals.apiUrl + '/api/CRM/ListaParaWorkflow');
  }

  consultarCRMComPaginacao(descricao: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao) {
    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao);

    if (descricao.trim() !== '') {
      parametros = parametros.set('descri', descricao);
    }

    return this.http.get<any>(globals.apiUrl + '/api/CRM/ListaPag',
      {
        params: parametros
      });
  }

  consultarPorIdCRM(idCRM) {
    return this.http.get<any>(globals.apiUrl + '/api/CRM/Buscar',
      { params: new HttpParams().set('id', idCRM) });
  }

  consultarEtapasDoCRM(idCRM) {
    return this.http.get<any>(globals.apiUrl + '/api/CRM/ListaEtapasDoCRM',
      { params: new HttpParams().set('idCRM', idCRM) });
  }

  consultaTipoDoCRM(tipoCRM) {
    return this.http.get<any>(globals.apiUrl + '/api/CRM/VerificaTipoDoCRM',
      { params: new HttpParams().set('tipoCRM', tipoCRM) }
    )
  }

  podeExcluirEtapa(idEtapa) {
    return this.http.get<any>(globals.apiUrl + '/api/CRM/PodeExcluirEtapa',
      { params: new HttpParams().set('idEtapa', idEtapa) });
  }

  salvar(funil: CRM) {
    return this.http.post(globals.apiUrl + '/api/CRM/Salvar', funil);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/CRM/Excluir',
      { params: new HttpParams().set('id', id) });
  }
}
